export const API = {
    AUTH: {
        login: '/auth/login',
        register: '/auth/register',
        logout: '/auth/logout',
    },
    USER: {
        checkMe: '/user/check-me',
        getUserAccounts: "/user/accounts",
        getUserShare: "/user/shares"
    },
    ACCOUNTS: {
        showAll: '/account-facebook/list',
        updateAccount: '/account-facebook/update',
        createAccount: '/account-facebook/create',
        deleteAccount: '/account-facebook/delete-multiple',
        getAccountsByIdGroup: '/account-facebook/get-by-group',
        removeAccountsGroup: '/account-facebook/leave-group',
        getAccountShared: "/account-facebook/shared",
        getAccountShareWithMe: "/account-facebook/share-with-me",
        addAccountUserProxy: "/account-facebook/user-proxy",
        deleteAccountUserProxy: "/account-facebook/user-proxy/delete-multiple"
    },
    SCRIPTS: {
        getScripts: '/script/list',
        updateScript: '/script/update',
        createScript: '/script/create',
        deleteScript: '/script/delete-multiple',
    },
    CODE: {
        update: '/code/update',
    },
    POSTS: {
        getPosts: '/article/list',
        updatePosts: '/article/update',
        createPosts: '/article/create',
        deletePosts: '/article/delete-multiple',
    },
    GROUPS: {
        getGroups: '/group/list',
        updateGroup: '/group/update',
        createGroup: '/group/create',
        deleteGroup: '/group/delete-multiple',
        addAccountToGroup: '/group/add-account-to-group',

    },
    PAGES: {
        getPages: '/page/list',
        updatePages: '/page/update',
        createPages: '/page/create',
        deletePages: '/page/delete-multiple',
    },
    GROUP_FBS: {
        createGroup: "/group-fb/create",
        getGroups: "/group-fb/list",
        deleteGroups: "/group-fb",
        search: "/group-fb/search",
        createMultiGroup: "/group-fb/create-multi"
    },
    PAGE_PROFILE: {
        getAll: "/page/all"
    },
    CATEGORY: {
        getCategories: "/category/list",
        updateCategory: "/category/update",
        createCategory: "/category/create",
        deleteCategories: "/category/delete-multiple"
    },
    QUESTION: {
        getAll: "/question/list",
        updateQuestion: "/question/update",
        createQuestion: "/question/create",
        deleteQuestions: "/question/delete-multiple"
    },
    LOCATION: {
        getAllProvince: "/location/province",
        getDistricts: "/location/district",
        getWards: "/location/ward"
    },
    TAG: {
        searchTags: "/tags/list"
    },
    SHARE: {
        create: "/share/create",
        delete: "/share/delete-multi"
    },
    COOKIE: {
        get: "/cookies/list"
    },
    LOG: {
        create: "/logs/create",
        get: "/logs/list"
    },
    USER_PROXY: {
        create: "/user-proxies/create",
        deleteMulti: "/user-proxies/delete-multiple",
        get: "/user-proxies/list",
        update: "/user-proxies/update"
    }
};
